import { Grid } from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";

import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import FaxIcon from "@mui/icons-material/Fax";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessIcon from "@mui/icons-material/Business";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import "./contact.css";
import PropTypes from "prop-types";
import { GROUP_NUMBER } from "../../../../constants/groupNumber/groupNumber";

interface IGroupNumberProp {
	groupNumber: number;
}

const Contact: React.FC<IGroupNumberProp> = ({ groupNumber }) => {
	const { theme } = useContext(ThemeContext);

	// console.log("GRoupnumbercheck---->", groupNumber);
	return (
		<div className="contact">
			<div className="contact-container theme-border-radius">
				{/* <div
					className="contact-header"
					style={{
						color: theme?.primary_color
					}}
				>
					Communicate with us
				</div> */}
				<div className="contact-details">
					<div className="theme-plan-inner-section-margin" />
					<Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<BusinessIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							<div>
								{groupNumber === GROUP_NUMBER.Progressive_Laboratories ||
								groupNumber === GROUP_NUMBER.Panhandle_First_Bank ||
								groupNumber === GROUP_NUMBER.Intercity_Investment
									? "Nexcaliber"
									: "Brookshire Brothers, Inc."}
							</div>
						</Grid>
					</Grid>
					<div className="theme-plan-inner-section-margin" />
					<Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<PeopleAltIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							<div>Benefits Department </div>
							<div>
								{groupNumber === GROUP_NUMBER.Progressive_Laboratories ||
								groupNumber === GROUP_NUMBER.Panhandle_First_Bank ||
								groupNumber === GROUP_NUMBER.Intercity_Investment
									? "Nexcaliber"
									: "Brookshire Brothers, Inc."}
							</div>
						</Grid>
					</Grid>
					<div className="theme-plan-inner-section-margin" />
					<Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<AddIcCallIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							{groupNumber === GROUP_NUMBER.Progressive_Laboratories ||
							groupNumber === GROUP_NUMBER.Panhandle_First_Bank ||
							groupNumber === GROUP_NUMBER.Intercity_Investment
								? "Phone: (800) 741-0185"
								: "Phone: (936) 634-8155, ext. 4676 "}
						</Grid>
					</Grid>
					<div className="theme-plan-inner-section-margin" />
					<Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<FaxIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							{groupNumber === GROUP_NUMBER.Progressive_Laboratories ||
							groupNumber === GROUP_NUMBER.Panhandle_First_Bank ||
							groupNumber === GROUP_NUMBER.Intercity_Investment
								? "Phone: (972) 248-1405"
								: "Fax: (936) 634-8646"}
						</Grid>
					</Grid>
					<div className="theme-plan-inner-section-margin" />
					{/* <Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<GroupsIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							<a className="staff-contact" href="http://www.nexcaliber.com/staff.html">
								Staff Contact
							</a>
						</Grid>
					</Grid> */}
					<div className="theme-plan-inner-section-margin" />
					<Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<AccessTimeIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							<div>Monday - Friday</div>
							<div className="timings">8.30 am - 5 pm</div>
						</Grid>
					</Grid>
					{/* <div className="theme-plan-inner-section-margin" /> */}
					{/* <Grid container>
						<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
							<ContactPageIcon
								style={{
									color: theme?.primary_color
								}}
							/>
						</Grid>
						<Grid item>
							<a className="staff-contact" href="contact-us">
								Contact Us
							</a>
						</Grid>
					</Grid> */}
				</div>
			</div>
		</div>
	);
};
Contact.propTypes = {
	groupNumber: PropTypes.number.isRequired
};

export default Contact;
